import React from 'react';
import { useNavigate } from 'react-router';
import { useAlert } from 'contexts/AlertContext';
import { PasswordForm } from 'components/settings';
import './ChangePassword.css';

export const ChangePassword: React.FC = () => {
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    const handleSubmit = async (currentPassword: string, newPassword: string) => {
        // TODO: 비밀번호 변경 로직 구현
        console.log('Password change:', { currentPassword, newPassword });
        await showAlert({ message: '비밀번호가 변경되었습니다.' });
        navigate('/settings/profile');
    };

    return (
        <div className="change-password-wrapper">
            <div className="change-password-header">
                <button className="back-button" onClick={() => navigate('/settings/profile')}>
                    ←
                </button>
                <h1 className="change-password-title">비밀번호 변경</h1>
            </div>

            <div className="change-password-content">
                <PasswordForm onSubmit={handleSubmit} />
            </div>
        </div>
    );
};
